<!-- @format -->

@if (data$ | async; as data) {
  @if (!suggestAttainment) {
    <div>
      <app-custom-study-draft-info
        [studyDraft]="data.studyDraft"
        [isSuggestButtonVisible]="data.isSuggestButtonVisible"
        (close)="cancel()"
        (suggestAttainment)="suggestAttainment = true"></app-custom-study-draft-info>
    </div>
  }
  @if (suggestAttainment) {
    <div>
      <app-apply-custom-study-draft-credit
        [options]="data.viewOptions"
        [studyDraftName]="data.studyDraft.name"
        [homeUniversityName]="data.homeUniversityName"
        (close)="cancel()"
        (back)="suggestAttainment = false"
        (suggestedAttainment)="this.startAttainmentApplicationProcess($event)"></app-apply-custom-study-draft-credit>
    </div>
  }
}
